import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Button } from '@fs/zion-ui'
import React, { useContext, useState } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { RelationshipCalculatorContext } from '../../relationshipCalculator/RelationshipCalculatorContext'
import { PersonContext } from '../PersonContext'
import { FactsSummary } from './FactsSummary'
import NameSummary from './NamesSummary'
import SexSummary from './SexSummary'
import { usePageTitle } from '../../app/PageTitleContext'

export default function PersonSummary() {
  usePageView({ page_detail: 'DMConsole:PersonSummary' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.summary'))
  const personContext = useContext(PersonContext)
  const currentPerson = personContext.currentPerson
  const relationshipCalculatorContext = useContext(RelationshipCalculatorContext)
  const [editable, setEditable] = useState(false)

  const floatRightCss = css`
    margin-inline-start: auto;
  `
  if (relationshipCalculatorContext) relationshipCalculatorContext.summary = true

  if (!currentPerson) {
    return null
  }

  const toggleEdit = () => {
    setEditable(!editable)
  }

  return (
    <>
      <span css={floatRightCss}>
        <Button emphasis="medium" id="summaryEditButton" onClick={toggleEdit}>
          {editable ? t('button.stopEditing', 'Stop Editing') : t('action.edit', 'Edit')}
        </Button>
      </span>
      <NameSummary editable={editable} />
      <SexSummary editable={editable} />
      <FactsSummary editable={editable} />
    </>
  )
}
